// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import HomeOne from './Components/HomeOne';
// import Header from './Components/Header/Header';
// import FooterOne from './Components/Footer/FooterOne';
// import AboutUs from './Components/AboutUs';
// import PageNotfound from './Components/PageNotfound';
// import NewsEvents from './Components/NewsEvents';
// import PartnerWithUs from './Components/PartnerWithUs';
// import VirtualTour from './Components/VirtualTour';
// import TreatmentPackages from './Components/TreatmentPackages';
// import Services from './Components/Services';
// import FAQs from './Components/FAQs';
// import BreatheClinic from './Components/BreatheClinic';
// import ServiceDetails from './Components/Page/ServiceDetails';
// import DentistDetails from './Components/Page/DentistDetails';
// import Blog from './Components/Page/Blog';
// import Contact from './Components/Contact';
// import Team from './Components/Page/Team';
// import BlogDetails from './Components/Page/BlogDetails';
// import FooterData from './Components/Data/FooterData';
// import './App.css';
// import ThankYouPage from './Components/ThankYouPage';

// // Create a CanonicalHelmet component using window.location.href
// const CanonicalHelmet = () => {
//   // Get the hostname and pathname from window.location
//   const baseUrl = 'https://sleeptherapeutics.in'; // This gives you https://sleeptherapeutics.in
//   const path = window.location.pathname; // This gives you the current path like "/about-us"
  
//   // Combine them to get the full canonical URL
//   const canonicalUrl = `${baseUrl}${path}`;
  
//   return (
//     <Helmet>
//       <link rel="canonical" href={canonicalUrl} />
//     </Helmet>
//   );
// };

// // Create a higher-order component to wrap each page component with the CanonicalHelmet
// const withCanonical = (Component) => {
//   return (props) => (
//     <>
//       <CanonicalHelmet />
//       <Component {...props} />
//     </>
//   );
// };

// // Apply the HOC to each component
// const HomeOneWithCanonical = withCanonical(HomeOne);
// const AboutUsWithCanonical = withCanonical(AboutUs);
// const NewsEventsWithCanonical = withCanonical(NewsEvents);
// const TreatmentPackagesWithCanonical = withCanonical(TreatmentPackages);
// const ServicesWithCanonical = withCanonical(Services);
// const PartnerWithUsWithCanonical = withCanonical(PartnerWithUs);
// const ServiceDetailsWithCanonical = withCanonical(ServiceDetails);
// const DentistDetailsWithCanonical = withCanonical(DentistDetails);
// const BlogDetailsWithCanonical = withCanonical(BlogDetails);
// const BlogWithCanonical = withCanonical(Blog);
// const TeamWithCanonical = withCanonical(Team);
// const ContactWithCanonical = withCanonical(Contact);
// const FAQsWithCanonical = withCanonical(FAQs);
// const BreatheClinicWithCanonical = withCanonical(BreatheClinic);
// const VirtualTourWithCanonical = withCanonical(VirtualTour);
// const ThankYouPageWithCanonical = withCanonical(ThankYouPage);

// function App() {
//   return (
//     <div className="main-wrapper">
//       <Router>
//         <Header />
//         <Routes>
//           {/* Redirect Old Paths to New URLs */}
//           {/* <Route path="/AboutUs" element={<Navigate to="/about-us" />} />
//           <Route path="/NewsEvents" element={<Navigate to="/news-events" />} /> */}
//           {/* <Route path="/BreatheClinic" element={<Navigate to="/breathe-clinic" />} /> */}
//           {/* <Route path="/VirtualTour" element={<Navigate to="/virtual-tour" />} /> */}
//           {/* <Route path="/TreatmentPackages" element={<Navigate to="/treatment-packages" />} /> */}
//           {/* <Route path="/PartnerWithUs" element={<Navigate to="/partner-with-us" />} /> */}
//           {/* <Route path="/FAQs" element={<Navigate to="/faqs" />} /> */}

//           {/* Regular Routes with Canonical URLs */}
//           <Route path="/" caseSensitive={true} element={<HomeOneWithCanonical />} />
//           <Route path="/about-us" caseSensitive={true} element={<AboutUsWithCanonical />} />
//           <Route path="/news-events" caseSensitive={true} element={<NewsEventsWithCanonical />} />
//           <Route path="/treatment-packages" caseSensitive={true} element={<TreatmentPackagesWithCanonical />} />
//           <Route path="/services" caseSensitive={true} element={<ServicesWithCanonical />} />
//           <Route path="/partner-with-us" caseSensitive={true} element={<PartnerWithUsWithCanonical />} />
//           <Route path="/page/service-details" caseSensitive={true} element={<ServiceDetailsWithCanonical />} />
//           <Route path="/page/dentist-details" caseSensitive={true} element={<DentistDetailsWithCanonical />} />
//           <Route path="/page/blog-details" caseSensitive={true} element={<BlogDetailsWithCanonical />} />
//           <Route path="/page/blog" caseSensitive={true} element={<BlogWithCanonical />} />
//           <Route path="/page/team" caseSensitive={true} element={<TeamWithCanonical />} />
//           <Route path="/contact" caseSensitive={true} element={<ContactWithCanonical />} />
//           <Route path="/faqs" caseSensitive={true} element={<FAQsWithCanonical />} />
//           <Route path="/breathe-clinic" caseSensitive={true} element={<BreatheClinicWithCanonical />} />
//           <Route path="/virtual-tour" caseSensitive={true} element={<VirtualTourWithCanonical />} />
//           <Route path="/thank-you" caseSensitive={true} e
//           lement={<ThankYouPageWithCanonical />} />

//           {/* Handle 404 */}
//           <Route path="*" element={<PageNotfound />} />
//         </Routes>
//         <FooterOne FooterData={FooterData} />
//       </Router>
//     </div>
//   );
// }

// export default App;

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import HomeOne from './Components/HomeOne';
import Header from './Components/Header/Header';
import FooterOne from './Components/Footer/FooterOne';
import AboutUs from './Components/AboutUs';
import PageNotfound from './Components/PageNotfound';
import NewsEvents from './Components/NewsEvents';
import PartnerWithUs from './Components/PartnerWithUs';
import VirtualTour from './Components/VirtualTour';
import TreatmentPackages from './Components/TreatmentPackages';
import Services from './Components/Services';
import FAQs from './Components/FAQs';
import BreatheClinic from './Components/BreatheClinic';
import ServiceDetails from './Components/Page/ServiceDetails';
import DentistDetails from './Components/Page/DentistDetails';
import Blog from './Components/Page/Blog';
import Contact from './Components/Contact';
import Team from './Components/Page/Team';
import BlogDetails from './Components/Page/BlogDetails';
import FooterData from './Components/Data/FooterData';
import './App.css';
import ThankYouPage from './Components/ThankYouPage';
import SleepStudyAnalysis from './Components/Page/SleepStudyAnalysis';
import SleepStudyCost from './Components/Page/SleepStudyCost';

// HTTPS and WWW Redirect Component (unchanged)
const HTTPSRedirect = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const pathname = window.location.pathname;
    const search = window.location.search;
    const hash = window.location.hash;
    
    // Skip redirects for localhost and development environments
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('192.168.')) {
      return;
    }
    
    // Check if we need to redirect
    const needsHttpsRedirect = protocol === 'http:';
    const needsWwwRemoval = hostname.startsWith('www.');
    
    if (needsHttpsRedirect || needsWwwRemoval) {
      // Build the correct URL
      const correctHostname = hostname.startsWith('www.') ? hostname.substring(4) : hostname;
      const newUrl = `https://${correctHostname}${pathname}${search}${hash}`;
      
      // Redirect to the correct URL
      window.location.replace(newUrl);
      return;
    }
  }, []);

  return null;
};

// Simplified Trailing Slash Redirect Component
const TrailingSlashRedirect = () => {
  const location = useLocation();
  
  // Only redirect if we have a trailing slash and it's not the root path
  if (location.pathname !== '/' && location.pathname.endsWith('/')) {
    const newPath = location.pathname.slice(0, -1);
    return <Navigate to={newPath + location.search + location.hash} replace />;
  }
  
  return null;
};

// Canonical Helmet Component
const CanonicalHelmet = () => {
  const location = useLocation();
  const baseUrl = 'https://sleeptherapeutics.in';
  
  // Remove trailing slash for canonical URL (except root)
  const cleanPath = location.pathname !== '/' && location.pathname.endsWith('/') 
    ? location.pathname.slice(0, -1) 
    : location.pathname;
  const canonicalUrl = `${baseUrl}${cleanPath}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

// Higher-order component wrapper
const withCanonical = (Component) => {
  return (props) => (
    <>
      <TrailingSlashRedirect />
      <CanonicalHelmet />
      <Component {...props} />
    </>
  );
};

// Apply HOC to components
const HomeOneWithCanonical = withCanonical(HomeOne);
const AboutUsWithCanonical = withCanonical(AboutUs);
const NewsEventsWithCanonical = withCanonical(NewsEvents);
const TreatmentPackagesWithCanonical = withCanonical(TreatmentPackages);
const ServicesWithCanonical = withCanonical(Services);
const PartnerWithUsWithCanonical = withCanonical(PartnerWithUs);
const ServiceDetailsWithCanonical = withCanonical(ServiceDetails);
const DentistDetailsWithCanonical = withCanonical(DentistDetails);
const BlogDetailsWithCanonical = withCanonical(BlogDetails);
const BlogWithCanonical = withCanonical(Blog);
const TeamWithCanonical = withCanonical(Team);
const ContactWithCanonical = withCanonical(Contact);
const FAQsWithCanonical = withCanonical(FAQs);
const BreatheClinicWithCanonical = withCanonical(BreatheClinic);
const VirtualTourWithCanonical = withCanonical(VirtualTour);
const ThankYouPageWithCanonical = withCanonical(ThankYouPage);

function App() {
  return (
    <div className="main-wrapper">
      <HTTPSRedirect />
      
      <Router>
        <Header />
        <Routes>
          {/* Handle malformed URLs */}
          <Route 
            path="/partner-with-ushttp://sleeptherapeutics.in/contact" 
            element={<Navigate to="/contact" replace />} 
          />
          <Route 
            path="/contacthttps://sleeptherapeutics.in/contact" 
            element={<Navigate to="/contact" replace />} 
          />
          <Route 
            path="/serviceshttps://sleeptherapeutics.in/services" 
            element={<Navigate to="/services" replace />} 
          />
          <Route 
            path="/about-ushttps://sleeptherapeutics.in/faqs" 
            element={<Navigate to="/faqs" replace />} 
          />
          <Route 
            path="/faqshttps://sleeptherapeutics.in/faqs" 
            element={<Navigate to="/faqs" replace />} 
          />
          <Route 
            path="/virtual-tourhttps://sleeptherapeutics.in/contact" 
            element={<Navigate to="/contact" replace />} 
          />

          {/* Old URL Redirects */}
          <Route path="/treatment-packages" element={<Navigate to="/sleep-study-cost-in-hyderabad" replace />} />
          <Route path="/partner-with-us" element={<Navigate to="/partner-with-Best-sleep-apnea-specialist-Hyderabad" replace />} />
          <Route path="/contact" element={<Navigate to="/Contact-Best-Sleep-apnea-Speialist-in-India" replace />} />

          {/* Regular Routes */}
          <Route path="/" element={<HomeOneWithCanonical />} />
          <Route path="/about-us" element={<AboutUsWithCanonical />} />
          <Route path="/news-events" element={<NewsEventsWithCanonical />} />
          <Route path="/sleep-study-cost-in-hyderabad" element={<TreatmentPackagesWithCanonical />} />
          <Route path="/services" element={<ServicesWithCanonical />} />
          <Route path="/services/sleep-study" element={<SleepStudyAnalysis />} />
          <Route path="/partner-with-Best-sleep-apnea-specialist-Hyderabad" element={<PartnerWithUsWithCanonical />} />
          <Route path="/page/service-details" element={<ServiceDetailsWithCanonical />} />
          <Route path="/page/dentist-details" element={<DentistDetailsWithCanonical />} />
          <Route path="/page/blog-details" element={<BlogDetailsWithCanonical />} />
          <Route path="/page/blog" element={<BlogWithCanonical />} />
          <Route path="/page/team" element={<TeamWithCanonical />} />
          <Route path="/Contact-Best-Sleep-apnea-Speialist-in-India" element={<ContactWithCanonical />} />
          <Route path="/faqs" element={<FAQsWithCanonical />} />
          <Route path="/breathe-clinic" element={<BreatheClinicWithCanonical />} />
          <Route path="/virtual-tour" element={<VirtualTourWithCanonical />} />
          <Route path="/thank-you" element={<ThankYouPageWithCanonical />} />
         <Route path='/sleep-study-cost' element={<SleepStudyCost/>}/>
          

          {/* Blog Routes */}
          <Route path="/blog/treatment-sleep-snoring" element={<BlogDetailsWithCanonical />} />
          <Route path="/blog/impact-of-sleep-on-mental-processes-behavior-hyderabad" element={<BlogDetailsWithCanonical />} />

          {/* 404 Route */}
          <Route path="*" element={<PageNotfound />} />
        </Routes>
        <FooterOne FooterData={FooterData} />
      </Router>
    </div>
  );
}

export default App;